import { Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';


@Component({
  selector: 'tc-form-radio-input',
  templateUrl: './form-radio-input.component.html',
  styleUrls: ['./form-radio-input.component.scss'],
  imports: [
    ReactiveFormsModule,
  ],
})
export class FormRadioInputComponent {
  inputId = input.required<string>();
  inputName = input.required<string>();
  inputValue = input.required<unknown>();
  isDisabled = input<boolean>(false);
  inputFormControl = input<FormControl>(null);
}
